import React from "react";
import { createChatBotMessage } from "react-chatbot-kit";

import CustomMessage from "../components/CustomMessage/CustomMessage";

const config = {
  botName: "Reimo CamperBot",
  placeholderText: "jghjkhg",
  initialMessages: [
    createChatBotMessage(`Hallo, wie kann ich Ihnen weiterhelfen?`),
  ],

customComponents: {
  header: () => (
    <div style={{ borderTopRightRadius: "5px", borderTopLeftRadius: "5px", backgroundColor: "#efefef", fontFamily: "Arial", display: "flex", alignItems: "center", fontSize: "0.85rem", color: "#514f4f", padding: "12.5px", fontWeight: "bold" }}>
      Reimo Chatbot
    </div>
  ),
  botChatMessage: (props) => <CustomMessage {...props} />, // ← HIER!
},  
widgets: [
  {
    widgetName: "custom-message",
    widgetFunc: (props) => <CustomMessage {...props} />,
    mapStateToProps: ["messages"],
  },
  ],
};

export default config;
